import { render, staticRenderFns } from "./CDRQCard.vue?vue&type=template&id=23846fd9&scoped=true&"
import script from "./CDRQCard.vue?vue&type=script&lang=ts&"
export * from "./CDRQCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23846fd9",
  null
  
)

export default component.exports